<template>
    <div class="form-group">
        <label :for="getId" class="label">
            {{ label }}
            {{ required ? '*' : '' }}
        </label>

        <textarea 
            @input="handleInput"
            :value="value"
            :name="name"
            :required="required"
            :disabled="disabled"
            :id="getId"
            :placeholder="placeholder"
            class="form-control input"
            v-bind:class="{ 'is-invalid': error }"
            :maxlength="maxlength"
            :minlength="minlength"
            :rows="rows"
            :cols="cols"
            :readonly="readOnly"
        />
        
        <small
            v-if="helperText"
            class="form-text"
            v-bind:class="{ 'invalid-feedback': error, 'text-muted': !error }"
        >
            {{ helperText }}
        </small>
    </div>
</template>

<script>

export default {
    props: {
        id: {
            type: String,
            required: false,
        },
        label: {
            type: String,
            required: false,
        },
        value: {
            required: true,
        },
        name: {
            type: String,
            required: false,
        },
        error: {
            type: Boolean,
            required: false,
            default: false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        helperText: {
            type: String,
            required: false,
            default: null
        },
        placeholder: {
            type: String,
            required: false,
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        },
        readOnly: {
            type: Boolean,
            required: false,
            default: false
        },
        maxlength: {
            type: [String, Number],
            required: false,
            default: null
        },
        minlength: {
            type: [String, Number],
            required: false,
            default: null
        },
        rows: {
            type: [String, Number],
            required: false,
            default: null
        },
        cols: {
            type: [String, Number],
            required: false,
            default: 20
        },
    },
    data(){
        return {
            content: this.value,
            randomId: null,
        };
    },
    computed: {
        getId () {
            return this.id ? this.id : this.randomId
        }
    },
    methods: {
        handleInput(e) {
            let newValue = e.target.value
            if (this.type === 'number') {
                newValue = parseInt(newValue, 10)
            }
            this.$emit('input', newValue)
            this.$emit('change', newValue)
        },
    },
    mounted() {
        this.randomId = Math.random().toString(36).substr(2, 9)
    }
}
</script>

<style scoped lang="scss">
</style>
